import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import generateOnlyFilter from '../../extensions/waitlist/utils/generateOnlyFilter';
import generateApiQueryParams from '../../extensions/waitlist/utils/generateApiQueryParams';

const sortedTransactions = (txs) =>
  reverse(
    sortBy(txs, (tx) => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );

// ================ Action types ================ //

export const FETCH_ORDERS_OR_SALES_REQUEST = 'app/InboxPage/FETCH_ORDERS_OR_SALES_REQUEST';
export const FETCH_ORDERS_OR_SALES_SUCCESS = 'app/InboxPage/FETCH_ORDERS_OR_SALES_SUCCESS';
export const FETCH_ORDERS_OR_SALES_ERROR = 'app/InboxPage/FETCH_ORDERS_OR_SALES_ERROR';

const UPDATE_TRANSACTION_REFS = 'app/InboxPage/UPDATE_TRANSACTION_REFS';

// ================ Reducer ================ //

const entityRefs = (entities) =>
  entities.map((entity) => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  fetchInProgress: false,
  fetchOrdersOrSalesError: null,
  pagination: null,
  transactionRefs: [],
};

export default function inboxPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ORDERS_OR_SALES_REQUEST:
      return { ...state, fetchInProgress: true, fetchOrdersOrSalesError: null };
    case FETCH_ORDERS_OR_SALES_SUCCESS: {
      const transactions = sortedTransactions(payload.data.data);
      return {
        ...state,
        fetchInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    }
    case FETCH_ORDERS_OR_SALES_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchOrdersOrSalesError: payload };
    case UPDATE_TRANSACTION_REFS:
      return { ...state, transactionRefs: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchOrdersOrSalesRequest = () => ({ type: FETCH_ORDERS_OR_SALES_REQUEST });
const fetchOrdersOrSalesSuccess = (response) => ({
  type: FETCH_ORDERS_OR_SALES_SUCCESS,
  payload: response,
});
const fetchOrdersOrSalesError = (e) => ({
  type: FETCH_ORDERS_OR_SALES_ERROR,
  error: true,
  payload: e,
});
export const updateTransactionRefs = (newRefs) => ({
  type: UPDATE_TRANSACTION_REFS,
  payload: newRefs,
});

// ================ Thunks ================ //
export const removeAndAppendFromTransactionRefs =
  ({ removedId, appendId }) =>
  (dispatch, getState) => {
    const { transactionRefs } = getState().InboxPage;
    const newRefs = transactionRefs.filter((ref) => ref.id.uuid !== removedId);
    if (appendId) {
      newRefs.push({ id: appendId, type: 'transaction' });
    }
    dispatch(updateTransactionRefs(newRefs));
  };

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const { tab } = params;
  const onlyFilter = generateOnlyFilter(params);
  if (!onlyFilter) {
    return Promise.reject(new Error(`Invalid tab for InboxPage: ${tab}`));
  }

  dispatch(fetchOrdersOrSalesRequest());

  const apiQueryParams = generateApiQueryParams({ params, search });

  return sdk.transactions
    .query(apiQueryParams)
    .then((response) => {
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchOrdersOrSalesSuccess(response));
      return response;
    })
    .catch((e) => {
      dispatch(fetchOrdersOrSalesError(storableError(e)));
      throw e;
    });
};
